import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/hanbit/Dev/worktrees/bty-deploy-pr82/src/app/[locale]/bty/(public)/BtyPublicRouteLoadingShell.tsx");
